import AnvilIcon from './icons/AnvilIcon'
import ScrollIcon from './icons/ScrollIcon'
import CommunityIcon from './icons/CommunityIcon'
import './Features.css'

const Features = () => {
  const features = [
    {
      icon: <AnvilIcon />,
      title: 'Easy Setup',
      description: 'Auto-checker with easy advanced setup',
      color: 'blue'
    },
    {
      icon: <ScrollIcon />,
      title: 'Special Actions',
      description: 'Automate quests with actions like using items, talking to NPCs and more',
      color: 'red'
    },
    {
      icon: <CommunityIcon />,
      title: 'Active Community',
      description: 'Active community with constant updates',
      color: 'green'
    }
  ]

  return (
    <section className="features" id="recursos">
      <div className="features__container">
        <div className="features__grid">
          {features.map((feature, index) => (
            <div 
              key={index}
              className={`features__card features__card--${feature.color}`}
            >
              <div className="features__card-inner">
                <div className="features__icon-wrapper">
                  <div className="features__icon">
                    {feature.icon}
                  </div>
                </div>

                <div className="features__content">
                  <h3 className="features__title">{feature.title}</h3>
                  <p className="features__description">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
